export default "__VITE_ASSET__CsKk$DWl__"